import React from 'react';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';

import TextField from '@mui/material/TextField';

import { Catalog } from '../states/settingState';

type Props = {
  open: boolean;
  catalog?: Catalog;
  setEditCatalogName: (name: string) => void;
  handleCommit: (catalogId: string, name: string) => void;
  handleClose: () => void;
};

export const CatalogUpdateNameDialog: React.FC<Props> = (props) => {

  const onChangeWords = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = (event.target as HTMLInputElement).value;
    props.setEditCatalogName(value);
  };

  const handleOk = () => {
    if (props.catalog) {
      props.handleCommit(props.catalog.id, props.catalog.name);
    }
    props.handleClose();
  };

  return (
    <Dialog
      open={props.open}
      keepMounted
      onClose={props.handleClose}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle id="alert-dialog-slide-title">{"体系目次の名称を変更します"}</DialogTitle>
      <DialogContent>
        <TextField id="words" label="目次名称" value={props.catalog ? props.catalog.name : ''} sx={{margin: 2}} onChange={onChangeWords} />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleOk} color="primary">
          OK
        </Button>
        <Button onClick={props.handleClose} color="primary">
          キャンセル
        </Button>
      </DialogActions>
    </Dialog>
  );
};
